
import {
    CREATE_PRINTING_DC_FAILURE,
    CREATE_PRINTING_DC_REQUEST,
    CREATE_PRINTING_DC_SUCCESS,
    CREATE_USER_FORM_PRINTING_DC,
    FETCH_SINGLE_PRINTING_DC_FAILURE,
    FETCH_SINGLE_PRINTING_DC_REQUEST,
    FETCH_SINGLE_PRINTING_DC_SUCCESS,
    FETCH_PRINTING_DC_FAILURE,
    FETCH_PRINTING_DC_REQUEST,
    FETCH_PRINTING_DC_SUCCESS,
    NAVIGATE_PRINTING_DC_DETAILS,
    NAVIGATE_PRINTING_DC,
    PRINTING_DC_USERFORM_RESET,
    UPDATE_PRINTING_DC_FAILURE,
    UPDATE_PRINTING_DC_REQUEST,
    UPDATE_PRINTING_DC_SUCCESS,
    //DELETE_PRINTING_DC_REQUEST,
    //DELETE_PRINTING_DC_SUCCESS,
    //DELETE_PRINTING_DC_FAILURE,
    PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE,
    FETCH_PRINTING_DC_STYLE_REQUEST,
    FETCH_PRINTING_DC_STYLE_SUCCESS,
    FETCH_PRINTING_DC_STYLE_FAILURE,
    FETCH_PRINTING_DC_INVOICE_REQUEST,
    FETCH_PRINTING_DC_INVOICE_SUCCESS,
    FETCH_PRINTING_DC_INVOICE_FAILURE,
    RESET_PRINTING_DC_INVOICE,
    PRINTING_DC_PROGRAM_ID_REQUEST,
    PRINTING_DC_PROGRAM_ID_SUCCESS,
    PRINTING_DC_PROGRAM_ID_FAILURE,
    DELETE_PRINTING_DC_SUCCESS_CALL_OFF,
    DELETE_PRINTING_DC_FAILURE_CALL_OFF,
    DELETE_PRINTING_DC_REQUEST_CALL_OFF,
    HEADER_SEARCH_CALL_ONLOAD,
    NAVIGATE_PRINTING_DC_DETAILS_PRINT,
    PRINTING_PROCESS_PROGRAM_SUCCESS,
    PRINTING_PROCESS_PROGRAM_REQUEST,
    PRINTING_PROCESS_PROGRAM_FALIURE
} from './printingDC.actionsType';

export const PRINTING_DC = 'printingDc';

let initialState = {
    loading: false,
    printingDC: [],
    printingpartDCInvoice: [],
    printingDCStyle: [],
    userform: {
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldIsInHouseDelivery: true,
        fldIsInHouseProduction: false,
        fldGrandGrossValue: 0,
        fldOtherPlusValue: 0,
        fldOtherMinusValue: 0,
        fldGrandTotalValue: 0,
        fldRoundoff: 0,
        startDate: new Date().setDate(new Date().getDate() - 15),
        endDate: new Date(),
        unitId: 1
    },
    selectedPrintingDC: {},
    detailsId: '',
    activeKey: 1,
    isPrintingDC: false,
    printingDCSelectedValue: null,
    errorMessage: '',
    iperrorMessage: '',
    headerSearchCall: true,
};

export let printingDcReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PRINTING_DC_REQUEST:
        case FETCH_PRINTING_DC_INVOICE_REQUEST:
        case FETCH_PRINTING_DC_STYLE_REQUEST:
        case CREATE_PRINTING_DC_REQUEST:
        case FETCH_SINGLE_PRINTING_DC_REQUEST:
        case UPDATE_PRINTING_DC_REQUEST:
        case PRINTING_DC_PROGRAM_ID_REQUEST:
        case DELETE_PRINTING_DC_REQUEST_CALL_OFF:
        case PRINTING_PROCESS_PROGRAM_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDC: updatePayload
            };
        case HEADER_SEARCH_CALL_ONLOAD:
            return {
                ...state,
                loading: false,
                headerSearchCall: payload
            }
        case PRINTING_PROCESS_PROGRAM_SUCCESS:
            return {
                ...state,
                loading: false,
                ProcessProgram: updatePayload
            }
        case FETCH_PRINTING_DC_INVOICE_SUCCESS:
            return {
                ...state,
                loading: false,
                printingpartDCInvoice: updatePayload
            };
        case FETCH_PRINTING_DC_STYLE_SUCCESS:
            return {
                ...state,
                loading: false,
                printingDCStyle: updatePayload?.PONO
            };
        case PRINTING_DC_PROGRAM_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fldFkProgramId: updatePayload?.fldFKProgram
            };
        case PRINTING_DC_PROGRAM_ID_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: updatePayload
            };
        case FETCH_SINGLE_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDC: updatePayload,
                userform: {
                    ...updatePayload, startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                }

            };
        case UPDATE_PRINTING_DC_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedPrintingDC: {},
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                detailsId: ''
            };
        case DELETE_PRINTING_DC_SUCCESS_CALL_OFF:
            return {
                ...state,
                loading: false,
                callOffCheck: updatePayload
            };
        // case DELETE_PRINTING_DC_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         userform: {
        //             fldFKDeliveryAt: '',
        //             fldFKSupplierID: '',
        //             fldIsInHouseDelivery: true,
        //             fldIsInHouseProduction: false,
        //             fldGrandGrossValue: 0,
        //             fldOtherPlusValue: 0,
        //             fldOtherMinusValue: 0,
        //             fldGrandTotalValue: 0,
        //             fldRoundoff: 0
        //         },
        //         detailsId: '',
        //         selectedPrintingDC: {}
        //     };
        case FETCH_PRINTING_DC_FAILURE:
        case FETCH_PRINTING_DC_INVOICE_FAILURE:
        case FETCH_PRINTING_DC_STYLE_FAILURE:
        case FETCH_SINGLE_PRINTING_DC_FAILURE:
        case CREATE_PRINTING_DC_FAILURE:
        case UPDATE_PRINTING_DC_FAILURE:
        case DELETE_PRINTING_DC_FAILURE_CALL_OFF:
        case PRINTING_PROCESS_PROGRAM_FALIURE:
            //case DELETE_PRINTING_DC_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_PRINTING_DC:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case RESET_PRINTING_DC_INVOICE:
            return {
                ...state,
                printingpartDCInvoice: []
            };
        case PRINTING_DC_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                selectedPrintingDC: {},
                detailsId: '',
                activeKey: 1
            };
        case NAVIGATE_PRINTING_DC_DETAILS:
            return {
                ...state,
                isPrintingDC: true,
                loading: false,
                printingDCSelectedValue: updatePayload.printingDCSelectedValue
            };
        case NAVIGATE_PRINTING_DC:
            return {
                ...state,
                isPrintingDC: false
            };
        case NAVIGATE_PRINTING_DC_DETAILS_PRINT:
            return {
                ...state,
                isPrintingDC: false,
                loading: false,
                printingDCSelectedValue: updatePayload.printingDCSelectedValue
            };
        case PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 2
            };
        case PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE:
            return {
                ...state,
                userform: {
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldIsInHouseDelivery: true,
                    fldIsInHouseProduction: false,
                    fldGrandGrossValue: 0,
                    fldOtherPlusValue: 0,
                    fldOtherMinusValue: 0,
                    fldGrandTotalValue: 0,
                    fldRoundoff: 0,
                    startDate: state.userform.startDate,
                    endDate: state.userform.endDate,
                    unitId: state.userform.unitId
                },
                activeKey: 1
            };
        default:
            return state;
    }
};
